import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import NewUserForm from '../../components/User Management/User Forms/NewUserForm';
import EditUserForm from '../../components/User Management/User Forms/EditUserForm';
import UserRole from '../../../shared/AuthRoles';
import ViewIndividualUser from '../../components/User Management/ViewIndividualUser';
import { CustomSmallListChip } from '../../../layout/styledcomponents/CustomChip';
import { CustomIconButton } from '../../../layout/styledcomponents/CustomIconButton';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useState } from 'react';
import { useGetIndividualUserInfoQuery } from '../../../app/Slices/SevenDayApiSlice';
import LoadingComponent from '../../../layout/styledcomponents/LoadingAnimations/LoadingComponent';
import ConfirmationModal from '../../shared/ConfirmationModal';
import React from 'react';
import { ContractorRole } from '../../enums/users';

export default function UserFormPage() {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const isIpad = useMediaQuery('(max-width: 1200px)');
    const loggedInUser = UserRole();
    const navigate = useNavigate();
    const [url, setUrl] = useState('');
    const { data: getIndividualUser, isFetching } =
        useGetIndividualUserInfoQuery(url);
    const [open, setOpen] = useState(false);
    const urlRef = window.location.href.split('/')[5];

    const theme = useTheme();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (
            loggedInUser?.role === 'guest_user' ||
            loggedInUser?.role === 'owner_user'
        ) {
            navigate(`/permissionDenied`, {
                state: {
                    name: 'newUserPage',
                },
            });
        }

        if (urlRef !== undefined) {
            if (
                loggedInUser?.role === 'owner_admin' ||
                loggedInUser?.role === 'owner_company' ||
                loggedInUser?.role === 'owner_user'
            ) {
                setUrl(`/owners/${loggedInUser?.company}/users/${urlRef}`);
            } else if (
                loggedInUser?.role === 'guest_admin' ||
                loggedInUser?.role === 'guest_company' ||
                loggedInUser?.role === 'guest_department_admin'
            ) {
                setUrl(`/guests/${loggedInUser?.company}/users/${urlRef}`);
            } else if (loggedInUser?.role === ContractorRole.Admin) {
                setUrl(`/contractors/${loggedInUser?.company}/users/${urlRef}`);
            } else {
                setUrl(`/7-day/users/${urlRef}`);
            }
        }
    }, [loggedInUser?.company]);

    const editUser = () => {
        navigate(
            `/editUser/${getIndividualUser?.firstName}/${getIndividualUser?.id}`,
            {
                state: {
                    name: 'editUser',
                },
            },
        );
    };

    const handleChangeModal = () => {
        setOpen(false);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    return (
        <>
            {isFetching === true ? (
                <Grid
                    sx={{
                        height: '100%',
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        alignContent: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LoadingComponent />
                </Grid>
            ) : (
                <Grid
                    sx={{
                        width: '100%',
                        height: isMobile || isIpad ? '100%' : '80%',
                        justifyContent: 'left',
                        alignItems: 'center',
                    }}
                >
                    <Grid
                        sx={{
                            width: '100%',
                            minHeight: 'auto',
                            justifyContent: 'left',
                        }}
                    >
                        {window.location.href?.includes('newUser') ? (
                            <Typography
                                variant='h1'
                                sx={{
                                    textAlign: 'left',
                                    textTransform: 'uppercase',
                                    mb: { xs: 2, sm: 3 },
                                }}
                            >
                                New User
                            </Typography>
                        ) : window.location.href?.includes('user') ? (
                            <>
                                <Typography
                                    variant='h1'
                                    sx={{
                                        textAlign: 'left',
                                        textTransform: 'uppercase',
                                        fontWeight:
                                            window.location.href?.includes(
                                                'user',
                                            )
                                                ? '550'
                                                : 'none',
                                        paddingRight: '15px',
                                    }}
                                >
                                    {' '}
                                    {getIndividualUser?.firstName}{' '}
                                    {getIndividualUser?.lastName}
                                </Typography>
                                <Typography>
                                    <CustomSmallListChip
                                        size='small'
                                        style={{
                                            border: 0,
                                            backgroundColor:
                                                getIndividualUser?.role?.includes(
                                                    ['admin'],
                                                ) ||
                                                loggedInUser?.role === 'admin'
                                                    ? theme.palette.textAccent
                                                          .main
                                                    : theme.palette.lightGrey
                                                          .main,
                                            color:
                                                getIndividualUser?.role?.includes(
                                                    ['admin'],
                                                ) ||
                                                loggedInUser?.role === 'admin'
                                                    ? theme.palette.neutral.main
                                                    : theme.palette.midGrey
                                                          .main,
                                        }}
                                        label={
                                            getIndividualUser?.role ===
                                                'owner_admin' ||
                                            loggedInUser?.role === 'admin'
                                                ? 'ADMIN'
                                                : getIndividualUser?.role ===
                                                    'guest_admin'
                                                  ? 'COMPANY ADMIN'
                                                  : getIndividualUser?.role ===
                                                      'guest_department_admin'
                                                    ? 'TEAM ADMIN'
                                                    : 'USER'
                                        }
                                        variant='outlined'
                                    />
                                </Typography>
                            </>
                        ) : (
                            <Typography
                                variant='h1'
                                sx={{
                                    textAlign: 'left',
                                    textTransform: 'uppercase',
                                }}
                            >
                                Edit User
                            </Typography>
                        )}
                    </Grid>
                    <Grid sx={{ width: '100%', textAlign: 'right' }}>
                        {window.location.href?.includes('editUser') ||
                        window.location.href?.includes('newUser') ? null : (
                            <>
                                <CustomIconButton
                                    sx={{
                                        backgroundColor:
                                            theme.palette.neutral.main,
                                        width: '25px',
                                        height: '25px',
                                        paddingLeft: '20px',
                                    }}
                                    onClick={editUser}
                                >
                                    <EditIcon
                                        fontSize='small'
                                        sx={{
                                            fontSize: '16px',
                                            '&:hover': {
                                                cursor: 'pointer',
                                                color: theme.palette.textAccent
                                                    .main,
                                                backgroundColor: 'transparent',
                                                background: 'none',
                                            },
                                        }}
                                    />
                                </CustomIconButton>
                            </>
                        )}
                    </Grid>
                    {window.location.href?.includes('newUser') ? (
                        <NewUserForm />
                    ) : window.location.href?.includes('editUser') ? (
                        <EditUserForm user={getIndividualUser} />
                    ) : (
                        <ViewIndividualUser />
                    )}
                </Grid>
            )}
            <ConfirmationModal
                open={open}
                onClose={handleCloseModal}
                onChange={handleChangeModal}
                message={'delete this user'}
                component={'user'}
            />
        </>
    );
}
